import { useTranslations } from '@eliadmin/core/src/hooks/use-translations';

export const SystemInstallationOnDomainServer = () => {
  const { t } = useTranslations();

  return (
    <div>
      <h1 className="py-4 text-3xl font-bold sm:py-6 sm:text-4xl md:text-5xl">{t('text1215')}</h1>
    </div>
  );
};
